import { SidebarMenuButton, SidebarMenuItem } from '@/app/_components/ui/sidebar';
import Link from '@/app/_adapters/next-link';
import { LucideIcon } from 'lucide-react';

interface SidebarMenuItemLinkProps {
  title: string;
  href: string;
  icon: LucideIcon;
  isCollapsed: boolean;
  pathname: string;
  isMobile: boolean;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
}

export function SidebarMenuItemLink({
  title,
  href,
  icon: Icon,
  isCollapsed,
  pathname,
  isMobile,
  openMobile,
  setOpenMobile,
}: SidebarMenuItemLinkProps) {
  const active = pathname?.startsWith(href) ?? false;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        isActive={active}
        tooltip={title}
        className="hover:cursor-pointer px-5"
      >
        <Link
          href={href}
          onClick={() => {
            if (isMobile && openMobile) setOpenMobile(false);
          }}
        >
          <Icon />
          {!isCollapsed && <span>{title}</span>}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
